"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
function Card({ children, className, contentStyle, title }, ref) {
    return ((0, jsx_runtime_1.jsxs)(Container, { ref: ref, className: className, children: [title && (0, jsx_runtime_1.jsx)(Header, { children: title }), (0, jsx_runtime_1.jsx)(Content, { style: contentStyle, children: children })] }));
}
exports.default = (0, react_1.forwardRef)(Card);
const Container = styled_components_1.default.div `
  overflow: hidden;

  background: ${({ theme }) => theme.designSystem.contentBackground};

  border-radius: 4px;
`;
const Content = styled_components_1.default.div `
  padding: 10px 4px;

  font-size: 13px;
`;
const Header = styled_components_1.default.div `
  color: ${({ theme }) => theme.grasshopper.text.white};

  font-size: 16px;

  text-align: left;
`;
